import { lazyLoad } from 'utils/loadable';

export const FaqPage = lazyLoad(
  () => import('./FaqPage'),
  module => module.FaqPage,
);
